import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../context/AuthContext'
import { useLangPrefix } from '../hooks/useLocalePath'
import SEO from '../components/SEO'
import '../styles/Auth.css'

export default function Login() {
  const { t } = useTranslation()
  const langPrefix = useLangPrefix()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
      navigate(langPrefix + '/dashboard')
    } catch (err) {
      setError(err.response?.data?.message || t('login.errorDefault'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <SEO
        title={t('login.seo.title')}
        description={t('login.seo.description')}
        path="/login"
      />
      <div className="auth-card">
        <div className="auth-logo">
          <span className="auth-logo-gradient">ReviewSight</span>
        </div>

        <h1 className="auth-title">{t('login.title')}</h1>
        <p className="auth-subtitle">{t('login.subtitle')}</p>

        {error && (
          <div className="auth-error" role="alert">
            <span className="auth-error-icon">⚠</span>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form" noValidate>
          <div className="form-group">
            <label htmlFor="email" className="form-label">{t('login.emailLabel')}</label>
            <input
              id="email"
              type="email"
              className="form-input"
              placeholder={t('login.emailPlaceholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">{t('login.passwordLabel')}</label>
            <input
              id="password"
              type="password"
              className="form-input"
              placeholder={t('login.passwordPlaceholder')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? (
              <span className="btn-loading">
                <span className="spinner" />
                {t('login.submitLoading')}
              </span>
            ) : (
              t('login.submit')
            )}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            {t('login.noAccount')}{' '}
            <Link to={langPrefix + '/register'} className="auth-link">{t('login.createAccount')}</Link>
          </p>
        </div>
      </div>
    </div>
  )
}
